import { useContext } from 'react';
import NotificationsContext from '../contexts/NotificationsContext';

const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};

export default useNotificationsContext;
